export default {"src":"/_next/static/media/uk-trade-logo.ffd1457f.svg","height":85,"width":290,"blurWidth":0,"blurHeight":0};